import { request } from '../utils/request';
import i18n from '../utils/i18n';

export async function getAllAuctionsAPI() {
  try {
    const response = await request({
      url: '/api/get-all-auctions',
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      timeout: 5000,
    });

    const data: any = response;
    console.log('data:', data);

    if (data && data.auctions) {
      return { success: true, result: { auctions: data.auctions } };
    } else {
      return { success: true, result: { auctions: [] } };
    }
  } catch (error) {
    console.error('Error fetching auctions:', error);
    throw error;
  }
}

export async function insertTennisOrderAPI(payload: {
  auction_id: number | string;
  buyer_id: number | string;
  price: number | string | number;
  paypay_account?: string | null;
  buyer_email?: string | null;
  paypay_qr_url?: string | null;
  lang?: 'zh' | 'ja' | string;
  status?: string;
}) {
  try {
    // 优先使用显式传入的 lang，否则使用当前 i18n.language（仅保留 zh/ja），再回退到 'ja'
    const lang = payload.lang === 'zh' || payload.lang === 'ja'
      ? payload.lang
      : (i18n.language === 'zh' || i18n.language === 'ja' ? i18n.language : 'ja');
    const body = { ...payload, lang };
    const response: any = await request({
      url: '/api/insert-tennis-order',
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: body,
      timeout: 10000,
    });

    // 后端返回结构示例： { success: true, message: 'Order created', orderId: ... }
    return response;
  } catch (error) {
    console.error('insertTennisOrderAPI error:', error);
    throw error;
  }
}

export async function getTennisOrderAPI(opts: {
  oid?: number | string;     // 有些后端实现使用 oid 参数
  buyerId?: number | string; // 查询购买者相关订单
  sellerId?: number | string; // 查询卖家相关订单
}) {
  try {
    const params = new URLSearchParams();
    if (opts.oid !== undefined) params.append('oid', String(opts.oid));
    if (opts.buyerId !== undefined) params.append('buyerId', String(opts.buyerId));
    if (opts.sellerId !== undefined) params.append('sellerId', String(opts.sellerId));

    const query = params.toString();
    const url = `/api/get-all-tennisOrder${query ? `?${query}` : ''}`;

    const response: any = await request({
      url,
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      timeout: 8000,
    });

    return response;
  } catch (error) {
    console.error('getTennisOrderAPI error:', error);
    throw error;
  }
}

export async function sendReservationAssetsAPI(payload: {
  email: string;
  venueName: string;
  date: string;
  timeRange: string;
  orderId: number | string;
  qrcodePath?: string | null;
  reservationScreenshotPath?: string | null;
  lang?: 'zh' | 'ja' | string;
}) {
  try {
    const response: any = await request({
      url: '/api/send-tennis-reservation',
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: payload,
      timeout: 15000,
    });
    return response;
  } catch (error) {
    console.error('sendReservationAssetsAPI error:', error);
    throw error;
  }
}

export async function updateTennisOrderStatusAPI(oid: number | string, status: string) {
  try {
    const response: any = await request({
      url: '/api/update-tennis-order-status',
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: { oid, status },
      timeout: 5000,
    });
    const data: any = response;
    console.log('updateTennisOrderStatusAPI response:', data);

    if (data && data.success) {
      return { success: true, result: data };
    } else {
      throw new Error(data?.message || 'Failed to update tennis order status');
    }
  } catch (error) {
    console.error('updateTennisOrderStatusAPI error:', error);
    throw error;
  }
}